// import React, { useState, useEffect } from "react";
// import i18n from "../i18n.js";
// import { useNavigate, useLocation } from "react-router-dom";
// import Button from "@mui/material/Button";
// import { useForm, Controller } from "react-hook-form";
// import Box from "@mui/material/Box";
// import LinearProgress from "@mui/material/LinearProgress";
// import TextField from "@mui/material/TextField";
// import Stack from "@mui/material/Stack";

// import Container from "@mui/material/Container";
// import axios from "axios";
// import Divider from "@mui/material/Divider";
// import InputLabel from "@mui/material/InputLabel";
// import MenuItem from "@mui/material/MenuItem";
// import FormControl from "@mui/material/FormControl";
// import Select from "@mui/material/Select";
// // import { FormContainer, TextFieldElement } from "react-hook-form-mui";

// const FormCouple = props => {
//     // eslint-disable-next-line react/prop-types
//     const { itemOptions } = props;
//     const { api, comp } = itemOptions;
//     const { t } = i18n;
//     const navigate = useNavigate();
//     const [loading, setLoading] = useState(false);
//     const [countries, setCountries] = useState([]);

//     const [code, setCode] = useState("");
//     let { state } = useLocation();
//     useEffect(() => {
//         setCode(state?.code);
//     }, []);
//     const {
//         handleSubmit,
//         control,
//         watch,
//         reset,
//         formState: { errors, isValid }
//     } = useForm({
//         defaultValues: {
//             firstName: "",
//             lastName: "",
//             year: "",
//             firstName2: "",
//             lastName2: "",
//             year2: "",
//             email: "",
//             city: "",
//             club: "",
//             // country: "",
//             country: ""
//         }
//     });
//     useEffect(() => {
//         setLoading(true);
//         axios
//             .get(`${api.getCountryList}`)
//             .then(res => {
//                 if (res.status === 200) {
//                     let tmp = [];
//                     res.data.forEach(element => {
//                         tmp.push({ label: element.name, id: element.id });
//                         // tmp.push(element.name);
//                     });
//                     reset({
//                         firstName: "",
//                         lastName: "",
//                         year: "",
//                         firstName2: "",
//                         lastName2: "",
//                         year2: "",
//                         email: "",
//                         city: "",
//                         club: "",
//                         // country: tmp[0].label,
//                         country: "Albania"
//                     });

//                     setCountries(tmp);
//                 }
//             })
//             .catch(function(error) {
//                 console.log(error);
//             });
//         setLoading(false);
//     }, []);
//     const onSubmit = data => {
//         if (isValid || Object.entries(errors).length === 0) {
//             navigate("/categories", {
//                 state: {
//                     firstName: data.firstName,
//                     lastName: data.lastName,
//                     year: data.year,
//                     firstName2: data.firstName2,
//                     lastName2: data.lastName2,
//                     idCountry: data.country,
//                     city: data.city,
//                     club: data.club,
//                     year2: data.year2,
//                     couple: null,
//                     team: null,
//                     email: data.email,
//                     fromWdsf: false,
//                     fromForm: true,
//                     isSolo: false,
//                     isCouple: true,
//                     isTeam: false
//                 }
//             });
//         } else {
//             console.log(errors);
//         }
//     };
//     const onError = (errors, e) => {
//         console.log(errors);
//     };

//     return (
//         <React.Fragment>
//             <hr />
//             <h2 className="display-6 mt-2">{t("reg.wdsf.couple")}</h2>
//             <p>{t("reg.info.form.couple")}</p>
//             {!loading && (
//                 <Container maxWidth="xs" className="mb-2">
//                     <Box>
//                         <form onSubmit={handleSubmit(onSubmit, onError)}>
//                             <Stack direction="column" spacing={{ xs: 1, sm: 1, md: 2 }}>
//                                 <Controller
//                                     name="firstName"
//                                     control={control}
//                                     rules={{ required: true }}
//                                     render={({ field }) => (
//                                         <TextField
//                                             {...field}
//                                             label={`${t("first_name")} (${t("man")})`}
//                                             type="text"
//                                             required
//                                             error={errors.firstName !== undefined}
//                                             helperText={errors.firstName !== undefined ? t("reg.wdsf.helper.not_empty") : ""}
//                                         />
//                                     )}
//                                 />
//                                 <Controller
//                                     name="lastName"
//                                     control={control}
//                                     rules={{ required: true }}
//                                     render={({ field }) => (
//                                         <TextField
//                                             {...field}
//                                             label={`${t("last_name")} (${t("man")})`}
//                                             type="text"
//                                             required
//                                             error={errors.lastName !== undefined}
//                                             helperText={errors.lastName !== undefined ? t("reg.wdsf.helper.not_empty") : ""}
//                                         />
//                                     )}
//                                 />
//                                 <Controller
//                                     name="year"
//                                     control={control}
//                                     rules={{ required: true, min: 1900, max: 2099 }}
//                                     render={({ field }) => (
//                                         <TextField
//                                             {...field}
//                                             label={`${t("reg.birth_year")} (${t("man")})`}
//                                             type="number"
//                                             min="1900"
//                                             max="2099"
//                                             step="1"
//                                             required
//                                             error={errors.year !== undefined}
//                                             helperText={errors.year !== undefined ? t("reg.wdsf.helper.year") : ""}
//                                         />
//                                     )}
//                                 />
//                                 <Divider />
//                                 <Controller
//                                     name="firstName2"
//                                     control={control}
//                                     rules={{ required: true }}

//                                     render={({ field }) => (
//                                         <TextField
//                                             {...field}
//                                             label={`${t("first_name")} (${t("woman")})`}
//                                             type="text"
//                                             required
//                                             error={errors.firstName2 !== undefined}
//                                             helperText={errors.firstName2 !== undefined ? t("reg.wdsf.helper.not_empty") : ""}
//                                         />
//                                     )}
//                                 />
//                                 <Controller
//                                     name="lastName2"
//                                     control={control}
//                                     rules={{ required: true }}

//                                     render={({ field }) => (
//                                         <TextField
//                                             {...field}
//                                             label={`${t("last_name")} (${t("woman")})`}
//                                             type="text"
//                                             required
//                                             error={errors.lastName2 !== undefined}
//                                             helperText={errors.lastName2 !== undefined ? t("reg.wdsf.helper.not_empty") : ""}
//                                         />
//                                     )}
//                                 />
//                                 <Controller
//                                     name="year2"
//                                     control={control}
//                                     rules={{ required: true, min: 1900, max: 2099 }}
//                                     render={({ field }) => (
//                                         <TextField
//                                             {...field}
//                                             label={`${t("reg.birth_year")} (${t("woman")})`}
//                                             type="number"
//                                             min="1900"
//                                             max="2099"
//                                             step="1"
//                                             required
//                                             error={errors.year2 !== undefined}
//                                             helperText={errors.year2 !== undefined ? t("reg.wdsf.helper.yaer") : ""}
//                                         />
//                                     )}
//                                 />
//                                 <Divider />
//                                 <Controller
//                                     name="city"
//                                     control={control}
//                                     rules={{ required: true }}
//                                     render={({ field }) => (
//                                         <TextField
//                                             {...field}
//                                             label={t("city")}
//                                             type="text"
//                                             required
//                                             error={errors.city !== undefined}
//                                             helperText={errors.city !== undefined ? t("reg.wdsf.helper.not_empty") : ""}
//                                         />
//                                     )}
//                                 />
//                                 <Controller
//                                     name="club"
//                                     control={control}
//                                     render={({ field }) => (
//                                         <TextField
//                                             {...field}
//                                             label={t("club")}
//                                             type="text"
//                                             error={errors.club !== undefined}
//                                             helperText={errors.club !== undefined ? t("reg.wdsf.helper.not_empty") : ""}
//                                         />
//                                     )}
//                                 />
//                                 <Controller
//                                     name="country"
//                                     control={control}
//                                     render={({ field }) => (
//                                         <FormControl fullWidth sx={{ textAlign: "left" }}>
//                                             <InputLabel id="country-label">{t("country")}</InputLabel>
//                                             <Select {...field} labelId="country-label" label={t("country")}>
//                                                 {countries.map(c => (
//                                                     <MenuItem key={c.id} value={c.label}>
//                                                         {c.label}
//                                                     </MenuItem>
//                                                 ))}
//                                             </Select>
//                                         </FormControl>
//                                     )}
//                                 />
//                                 <Controller
//                                     name="email"
//                                     control={control}
//                                     rules={{
//                                         pattern: /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
//                                     }}
//                                     render={({ field }) => (
//                                         <TextField
//                                             {...field}
//                                             label={t("email")}
//                                             type="email"
//                                             required
//                                             error={errors.email !== undefined}
//                                             helperText={errors.email !== undefined ? t("reg.wdsf.helper.email") : ""}
//                                         />
//                                     )}
//                                 />

//                                 {!loading && (
//                                     <Button type="submit" variant="outlined">
//                                         {t("confirm_proceed_to_categories")}
//                                     </Button>
//                                 )}
//                                 {loading && <LinearProgress />}
//                             </Stack>
//                         </form>
//                     </Box>
//                 </Container>
//             )}
//         </React.Fragment>
//     );
// };

// export default FormCouple;
import React, { useState, useEffect } from "react";
import i18n from "../i18n.js";
import { useNavigate, useLocation } from "react-router-dom";
import Button from "@mui/material/Button";
import { useForm, Controller } from "react-hook-form";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Container from "@mui/material/Container";
import axios from "axios";
import Divider from "@mui/material/Divider";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

const FormCouple = (props) => {
    const { itemOptions } = props;
    const { api } = itemOptions;
    const { t } = i18n;
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [countries, setCountries] = useState([]);
    const [code, setCode] = useState("");
    const [hobby, setHobby] = useState("");
    const [person, setPerson] = useState({});
    const { state } = useLocation();

    useEffect(() => {
        setCode(state.code);
        setHobby(state.hobby);
    }, [state]);

    const {
        handleSubmit,
        control,
        reset,
        formState: { errors, isValid }
    } = useForm({
        defaultValues: {
            firstName: "",
            lastName: "",
            year: "",
            firstName2: "",
            lastName2: "",
            year2: "",
            email: "",
            city: "",
            club: "",
            country: ""
        }
    });

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const countryResponse = await axios.get(`${api.getCountryList}`);
                if (countryResponse.status === 200) {
                    let tmp = [];
                    countryResponse.data.forEach((element) => {
                        tmp.push({ label: element.name, id: element.id });
                    });
                    setCountries(tmp);

                    reset({
                        firstName: "",
                        lastName: "",
                        year: "",
                        firstName2: "",
                        lastName2: "",
                        year2: "",
                        email: "",
                        city: "",
                        club: "",
                        country: "Poland"
                    });
                }

                if (hobby === true) {
                    const personResponse = await axios.get(`${api.apiGetPerson}`);
                    const p = personResponse.data;
                    setPerson(p);
                    if (p.clubs.length > 0) {
                        const club = p.clubs[0];
                        reset({
                            firstName: "",
                            lastName: "",
                            year: "",
                            firstName2: "",
                            lastName2: "",
                            year2: "",
                            email: club.email,
                            city: club.city,
                            club: club.shortName,
                            country: "Poland"
                        });
                    }
                }
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [hobby, api, reset]);

    const onSubmit = (data) => {
        if (isValid || Object.entries(errors).length === 0) {
            navigate("/categories", {
                state: {
                    firstName: data.firstName,
                    lastName: data.lastName,
                    year: data.year,
                    firstName2: data.firstName2,
                    lastName2: data.lastName2,
                    year2: data.year2,
                    idCountry: data.country,
                    city: data.city,
                    club: data.club,
                    couple: true,
                    team: null,
                    email: data.email,
                    fromWdsf: false,
                    fromForm: true,
                    isSolo: false,
                    isCouple: true,
                    isTeam: false,
                    isHobby: hobby,
                    code: code,
                }
            });
        } else {
            console.log(errors);
        }
    };

    const onError = (errors) => {
        console.log(errors);
    };

    return (
        <React.Fragment>
            <hr />
            <h2 className="display-6 mt-2">{t("reg.wdsf.couple")}</h2>
            <p>{t("reg.info.form.couple")}</p>
            {!loading && (
                <Container maxWidth="xs" className="mb-2">
                    <Box>
                        <form onSubmit={handleSubmit(onSubmit, onError)}>
                            <Stack direction="column" spacing={{ xs: 1, sm: 1, md: 2 }}>
                                <Controller
                                    name="firstName"
                                    control={control}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            label={`${t("first_name")}`}
                                            type="text"
                                            required
                                            error={errors.firstName !== undefined}
                                            helperText={errors.firstName !== undefined ? t("reg.wdsf.helper.not_empty") : ""}
                                        />
                                    )}
                                />
                                <Controller
                                    name="lastName"
                                    control={control}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            label={`${t("last_name")}`}
                                            type="text"
                                            required
                                            error={errors.lastName !== undefined}
                                            helperText={errors.lastName !== undefined ? t("reg.wdsf.helper.not_empty") : ""}
                                        />
                                    )}
                                />
                                <Controller
                                    name="year"
                                    control={control}
                                    rules={{ required: true, min: 1900, max: 2099 }}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            label={`${t("reg.birth_year")}`}
                                            type="number"
                                            min="1900"
                                            max="2099"
                                            step="1"
                                            required
                                            error={errors.year !== undefined}
                                            helperText={errors.year !== undefined ? t("reg.wdsf.helper.year") : ""}
                                        />
                                    )}
                                />
                                <Controller
                                    name="firstName2"
                                    control={control}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            label={`${t("first_name")} 2`}
                                            type="text"
                                            required
                                            error={errors.firstName2 !== undefined}
                                            helperText={errors.firstName2 !== undefined ? t("reg.wdsf.helper.not_empty") : ""}
                                        />
                                    )}
                                />
                                <Controller
                                    name="lastName2"
                                    control={control}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            label={`${t("last_name")} 2`}
                                            type="text"
                                            required
                                            error={errors.lastName2 !== undefined}
                                            helperText={errors.lastName2 !== undefined ? t("reg.wdsf.helper.not_empty") : ""}
                                        />
                                    )}
                                />
                                <Controller
                                    name="year2"
                                    control={control}
                                    rules={{ required: true, min: 1900, max: 2099 }}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            label={`${t("reg.birth_year")} 2`}
                                            type="number"
                                            min="1900"
                                            max="2099"
                                            step="1"
                                            required
                                            error={errors.year2 !== undefined}
                                            helperText={errors.year2 !== undefined ? t("reg.wdsf.helper.year") : ""}
                                        />
                                    )}
                                />
                                <Divider />
                                <Controller
                                    name="city"
                                    control={control}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            label={t("city")}
                                            type="text"
                                            required
                                            error={errors.city !== undefined}
                                            helperText={errors.city !== undefined ? t("reg.wdsf.helper.not_empty") : ""}
                                        />
                                    )}
                                />
                                <Controller
                                    name="club"
                                    control={control}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            label={t("club")}
                                            type="text"
                                            error={errors.club !== undefined}
                                            helperText={errors.club !== undefined ? t("reg.wdsf.helper.not_empty") : ""}
                                        />
                                    )}
                                />
                                {hobby !== true && (
                                    <Controller
                                        name="country"
                                        control={control}
                                        render={({ field }) => (
                                            <FormControl fullWidth sx={{ textAlign: "left" }}>
                                                <InputLabel id="country-label">{t("country")}</InputLabel>
                                                <Select {...field} labelId="country-label" label={t("country")}>
                                                    {countries.map((c) => (
                                                        <MenuItem key={c.id} value={c.label}>
                                                            {c.label}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        )}
                                    />
                                )}
                                <Controller
                                    name="email"
                                    control={control}
                                    rules={{
                                        pattern: /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
                                    }}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            label={t("email")}
                                            type="email"
                                            required
                                            error={errors.email !== undefined}
                                            helperText={errors.email !== undefined ? t("reg.wdsf.helper.email") : ""}
                                        />
                                    )}
                                />

                                {!loading && (
                                    <Button type="submit" variant="outlined">
                                        {t("confirm_proceed_to_categories")}
                                    </Button>
                                )}
                                {loading && <LinearProgress />}
                            </Stack>
                        </form>
                    </Box>
                </Container>
            )}
        </React.Fragment>
    );
};

export default FormCouple;